import { CacheableDataObject } from '../models/CacheableDataObject.jsx';
import { Character } from '../models/Character.jsx';
import { Users } from 'models/UserCollection';
import { Stage } from './Stage';
import { MatchGamePlayer } from 'models/MatchGamePlayer.jsx';
import moment from 'moment';
import MatchGameTeam from "./MatchGameTeam";
import MatchGameEnum from "./MatchGameEnum.js";

export class MatchGame extends CacheableDataObject {

	getPlayerCharacter(player) {
		const playerData = this.players[player.id];
		if(playerData) {
			return playerData.character;
		}
		return null;
	}

	getMyMatchGameTeam() {
		if(!this.match.containsMeAsPlayer()) {
			return null;
		}
		return this.teams[this.match.getMyTeamNumber()];
	}

	getMyCurrentCharacter() {
		const characterId = this.match.getMyCurrentCharacterId();
		if(!characterId) {
			return null;
		}
		const character = Character.retrieveById(characterId);
		if(character.name) {
			return character;
		}
		return null;
	}

	getReportFromTeam(teamNumber) {
		if(!teamNumber) {
			console.error('no team number?');
			return null;
		}
		const report = this.teams[teamNumber];
		if(report) {
			return report;
		}
		console.error('had no report at all?');
		return null;
	}

	teamLost(teamNumber) {
		if(!this.result) {
			return false;
		}
		return this.result === MatchGameEnum.RESULT_PLAYER_1_WON && teamNumber === 2
			|| this.result === MatchGameEnum.RESULT_PLAYER_2_WON && teamNumber === 1;
	}

	teamWon(teamNumber) {
		if(!this.result) {
			return false;
		}
		return this.result === MatchGameEnum.RESULT_PLAYER_1_WON && teamNumber === 1
			|| this.result === MatchGameEnum.RESULT_PLAYER_2_WON && teamNumber === 2;
	}

	getPlayersWithCharacterSelections() {
		const results = [];
		_.each(this.players, (matchPlayerCharacterThing, id) => {
			if(!matchPlayerCharacterThing.character) {
				return;
			}
			const player = Users.retrieveById(id);
			results.push({ player: player, character: matchPlayerCharacterThing.character });
		});
		return results;
	}

	getPlayerRandomCharacter(player) {
		const playerData = this.players[player.id];
		if(playerData && playerData.random_character) {
			return playerData.random_character;
		}
		return null;
	}

	getPlayersThatChoseCharacter(character) {
		const playersThatChose = [];
		$.each(this.players, function(id, player) {
			if(player.character === character.id) {
				const player = Users.findById(id);
				if(player) {
					playersThatChose.push(player);
				}
			}
		});
		return playersThatChose;
	}

	teamIsWaitingForCharacterPicks(teamNumber) {
		return this.current_action === MatchGameEnum.ACTION_PLAYER_1_PICK_CHARACTER && teamNumber == 2
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_2_PICK_CHARACTER && teamNumber == 1;

	}

	isPlayerTurnToPickCharacters(teamNumber) {
		return this.current_action === MatchGameEnum.ACTION_PLAYER_1_PICK_CHARACTER && teamNumber == 1
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_2_PICK_CHARACTER && teamNumber == 2;
	}

	isAtCharacterPicks() {
		return this.current_action === MatchGameEnum.ACTION_PLAYERS_BLIND_PICK_CHARACTERS
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_1_PICK_CHARACTER
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_2_PICK_CHARACTER;
	}

	shouldShowCharacterSelectionsForMe() {
		return this.current_action === MatchGameEnum.ACTION_PLAYERS_BLIND_PICK_CHARACTERS
			|| (this.match.getMyTeamNumber() === 1 && this.current_action === MatchGameEnum.ACTION_PLAYER_1_PICK_CHARACTER)
			|| (this.match.getMyTeamNumber() === 2 && this.current_action === MatchGameEnum.ACTION_PLAYER_2_PICK_CHARACTER);
	}

	isAtStagePicks() {
		return this.current_action === MatchGameEnum.ACTION_PLAYER_1_STRIKE_STAGE || this.current_action === MatchGameEnum.ACTION_PLAYER_2_STRIKE_STAGE
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_1_PICK_STAGE || this.current_action === MatchGameEnum.ACTION_PLAYER_2_PICK_STAGE
			|| this.current_action === MatchGameEnum.ACTION_PLAYER_1_BAN_STAGE || this.current_action === MatchGameEnum.ACTION_PLAYER_2_BAN_STAGE;

	}

	isAtPlayGamePhase() {
		return this.current_action === MatchGameEnum.ACTION_PLAYERS_PLAY_GAME ||
			this.current_action === MatchGameEnum.ACTION_FRIENDLY_REPORT ||
			this.current_action === MatchGameEnum.ACTION_FRIENDLY_PLAY_GAME;

	}

	isFriendlyPhase() {
		return this.current_action === MatchGameEnum.ACTION_FRIENDLY_REPORT || this.current_action === MatchGameEnum.ACTION_FRIENDLY_PLAY_GAME;
	}

}

MatchGame.prototype.dataLocationParsers = {
	current_action(game, data) {
		if(data.current_action) {
			game.current_action = Number.parseInt(data.current_action);
		}
		else {
			game.current_action = null;
		}
	},
	start_time(game, data) {
		game.start_time = moment.unix(data.start_time);
	},
	teams(game, data) {
		game.teams = {};
		_.each(data.teams, (team, number) => {
			game.teams[number] = MatchGameTeam.create({
				...team,
				number: number
			});
		});
	},
	stage_data: function(game, data) {
		game.stage_data = Stage.retrieve(data.stage_data);
	},
	players(game, data) {
		game.players = {};
		for(let i in data.players) {
			game.players[i] = MatchGamePlayer.create(data.players[i]);
		}
	},
	all_stages(game, data) {
		game.all_stages = {};
		for(let i in data.all_stages) {
			if(!data.all_stages.hasOwnProperty(i)) {
				continue;
			}
			const stageValue = data.all_stages[i];
			game.all_stages[i] = {
				id: i,
				status: stageValue,
				player: Number.isInteger(stageValue) ? Users.retrieveById(stageValue) : null
			};
		}
	}
};